export { BrowsePrimitivesIndexPage } from "#browse-primitives-index-page";
